
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../axios/axiosInstance";
import addThreeHoursToISO from "../../helper/date/addThreeHoursToISO";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axios from "axios";

const initialState = {

    //! bu seferin bitime ne kadar mesafe kaldığını gösteriyor
    remainingDistance: null,

    //! tahmini varislar
    tekSuruculuTahminiVaris: null,
    ciftSuruculuTahminiVaris: null,


    //! anasayfadaki locationları tutan
    homePageLocationData: {
        loadLocationList: [],
        yuklemedeLocationList: [],
        seferdeLocationList: [],
        bosaltmadaLocationList: []
    },

    //! bu listelerin(yükleme-sefer-bosaltma) üst kısmındaki haritada güzükecek her bir yükün sürücüsünün son konum bilgisi
    topPagesMapAllShipmentCurrentLocationList: [],

    //! bu listenin (tamamlanan) üst kısmındaki haritada güzükecek her bir yükün sürücüsünün son konum bilgisi
    topPagesMapAllTamamlananShipmentCurrentLocationList: [],

    //! bu listelerde(yükleme-sefer-bosaltma) seçilen bir yükün tüm location bilgisini tutan
    topPagesMapSingleShipmentItemLocationList: [],

    //! bu listede(tamamlanan) seçilen bir yükün tüm location bilgisini tutan
    topPagesMapSingleTamamlananShipmentItemLocationList: [],

    //! bu listelerde(yükleme-sefer-bosaltma) seçilen bir yükün en son location bilgisini tutan
    topPagesMapShipmentItemCurrentLocationData: null,

    //! bu listede(tamamlanan) seçilen bir yükün en son location bilgisini tutan
    topPagesMapTamamlananShipmentItemCurrentLocationData: null,

    //! bu seçilen yükün tüm location bilgilerini tutan ın loading bilgisi
    isLoadingGetShipmentDriverLocationsById: false,

    //! bu animasyon button kontrolleri (pause, animate, back, forward)
    animationControlType: "pause",

    //! bu animasyonun street view olarak mı olacağını gösteren
    liveStreetView: false,

    //! trafik durumunun gösterimini tutan
    isTrafficLayer: false,

    //! bu detay animasyon tabında sıranın hangi markerda(konum bilgisinde) olacağını gösteren 
    activeLocationOrderForAnimation:1,

    //! bu animasyon tabında animasyon un hızını gösteren
    animationControlSpeed: 1,

    //! bu animasyon tabının çizgi(route) mi yoksa icon(icon) mu olacağını ayarlayan
    animationViewType: "route",

    //! bu animasyon kısmında location pointlerden siyah olanları filtrelemek için
    locationPointPauseFilter: false,

    //! bu başlangıç tarihini filtreleyen
    filterStartDate: "",

    //! bu bitiş tarihini filtreleyen
    filterEndDate: "",

    //! max speed e göre filtreleme yapılacak değeri gösterir
    maxSpeedFilter: false,

    //! max speed e göre filtreleme yapılacak değeri gösterir
    maxSpeedValue:20,

    //! bu animasyon ile takip ederken haritaya focuslanıp focuslanmayacağını kontrol ediyor.
    animationFocusType: false,

    //! bu haritanın görünür alanındaki marker listesi (optimizasyon için)
    detailsVisibleMarkers: [],

    //! bu haritanın sağ üst köşesindeki location detaylarını tutan (marker a tıklama yada animasyon sırasında değişiyor) 
    detailsMarkerItem: null,

    //! bu detay haritasında hangi tab ın açık olacağını ayarlıyor
    activeTabId: 1,

    //! bunu animasyon tabında rotanın başı ve sonu arsındaki ilgili marker a(konum a) gitmek için ( slider üzerinde)
    animationControlRoute: 1,

    //! bu listelerde haritanın sağında veri kısmının gösterilmesini setleyen
    isActiveSide: false,


    //! ************************************************************

    //! bu shipment id ile paylaşım linki almak için istek atılan endpoint loading bilgisi
    isLoadingGetLocationTrackingShareLink: false,

    //! bu link paylaşımı için linki tutan veri
    locationTrackingShareLink: null,

    //! bu link paylaşımı için seçilen yükün shipment id si
    shareLinkShipmentId: null,

    //! bu mail ile link göndermenin loading i
    isLoadingSendShipmenLiveLocationShareLinkWithMail: false,

    //! bu sms ile link göndermenin loading i
    isLoadingSendShipmenLiveLocationShareLinkWithSms: false,

    //! tracking Data nın isLoading i
    isLoadingGetLocationTrackingData: false,


    //! tracking de sürücü bilgileri
    trackingDataDriverInfo: null,

    //! tracking de shipent in location listesi
    trackingDatalocationList: [],

    //! tracking de sürücünün en son konum bilgisi
    trackingDataCurrentDriverLocation: null,

    //! bu herhangi bir kullanıcı verisine gerek kalmadan yüke ait bilgiler için
    trackingDataLoadRoutePoints: []





}

export const getHomePageMapShipmentData = createAsyncThunk("topPagesMap/getHomePageMapShipmentData", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/ShipmentLocationHistories/GetAllLocations`)
        return {
            yuklemedeLocationList: data.yuklemedeLocations.$values,
            seferdeLocationList: data.seferdeLocations.$values,
            bosaltmadaLocationList: data.bosaltmadaLocations.$values
        }
    } catch (error) {
        
        return thunkApi.rejectWithValue(error)
    }
})

export const getHomePageMapLoadData = createAsyncThunk("topPagesMap/getHomePageMapLoadData", async(_, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/RoutePoints/GetFirstRoutePoints`)
        return {
            loadLocationList: data.$values
        }
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getShipmentDriverLocationsById = createAsyncThunk("topPagesMap/getShipmentDriverLocationsById", async({fromWhere,shipmentId}, thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/Shipment/getShipmentDriverLocationsById?id=${shipmentId}`)
        //! fromWhere === tamamlanan ise Tamamlanan sayfasından yoksa diğer sayfalardan
        return {
            fromWhere,
            data:data.data.liveLocationData.locations.map((item) => {
                return {
                    ...item,
                    createdDate: item?.createdDate
                }
            })
        }
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getLocationTrackingShareLink = createAsyncThunk("topPagesMap/getLocationTrackingShareLink", async(shipmentId, thunkApi)=> {
    try {
        
        const {data} = await axiosInstance.post(`/shipment/ShareShipment`, {id: shipmentId})

       return data
       
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getLocationTrackingData = createAsyncThunk("topPagesMap/getLocationTrackingData", async(rId, thunkApi)=> {
    try {
        
        const {data} = await axios.post(`${process.env.REACT_APP_API_URI}/shipment/TrackShipment`, {id: rId})

       const {
        currentDriverLocation,
        driverInfo,
        locations,
        shipmentId,
        routePoints

       } = data.data.liveLocationData

       const formattedLocationlist = locations.map((item) => {
        return {
            ...item,
            createdDate: addThreeHoursToISO(item?.createdDate)
        }
       })

       return {
        currentDriverLocation: {...currentDriverLocation,shipmentId },
        driverInfo: {...driverInfo, shipmentId},
        locations: formattedLocationlist,
        loadRoutePoints: routePoints
       }
       
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const sendShipmenLiveLocationShareLinkWithMail = createAsyncThunk("topPagesMap/sendShipmenLiveLocationShareLinkWithMail", async(body, thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`shipment/SendLiveLocationMail`, body)
         if (data.statusCode === 200) {
               thunkApi.dispatch(showModal("result"));
               thunkApi.dispatch(
                 setResultModalData({
                   msg: "Mail ile gönderme işlemi başarı ile gerçekleştirildi",
                   resultType: "success",
                   btnText1: "Harika",
                 })
               );
           }
       return data
       
    } catch (error) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
            setResultModalData({
            msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
            resultType: "error",
            btnText1: "Harika",
            })
        );
        return thunkApi.rejectWithValue(error)
    }
})

export const sendShipmenLiveLocationShareLinkWithSms = createAsyncThunk("topPagesMap/sendShipmenLiveLocationShareLinkWithSms", async(body, thunkApi)=> {
    try {

        const {data} = await axiosInstance.post(`shipment/SendLiveLocationSms`, body)
       if (data.statusCode === 200) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
          setResultModalData({
            msg: "SMS ile gönderme işlemi başarı ile gerçekleştirildi",
            resultType: "success",
            btnText1: "Harika",
          })
        );
    }
       return data
       
    } catch (error) {
        thunkApi.dispatch(showModal("result"));
        thunkApi.dispatch(
            setResultModalData({
            msg: "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
            resultType: "error",
            btnText1: "Harika",
            })
        );
        return thunkApi.rejectWithValue(error)
    }
})







const topPagesMapSlice = createSlice({
    name: "topPagesMap",
    initialState,
    reducers: {

        //! bu yukleme-sefer-bosaltma daki shipment ların en son location bilgilerini tutan
        setTopPagesMapAllShipmentCurrentLocationList: (state, action) => {
            state.topPagesMapAllShipmentCurrentLocationList = action.payload
        },

        //! bu ilgili shipment in en son location bilgisini tutan setleyen (yukleme-sefer-bosaltma)
        setTopPagesMapShipmentItemCurrentLocationData: (state,action) => {
            state.topPagesMapShipmentItemCurrentLocationData = state.topPagesMapAllShipmentCurrentLocationList.find((item) => {
                return item?.shipmentId === action?.payload
            })
        },
        
        //! bu tüm tamamlanan shipment ların en son location bilgilerini tutan
        setTopPagesMapAllTamamlananShipmentCurrentLocationList: (state, action) => {
            state.topPagesMapAllTamamlananShipmentCurrentLocationList = action.payload
        },
        
        //! bu ilgili shipment in en son location bilgisini tutan setleyen (tamamlanan)
        setTopPagesMapTamamlananShipmentItemCurrentLocationData: (state, action) => {
            state.topPagesMapTamamlananShipmentItemCurrentLocationData = state.topPagesMapAllTamamlananShipmentCurrentLocationList.find((item) => {
                return item?.shipmentId === action.payload
            })
        },

        //! bu animasyon kısmında button kontrolü (pause, forward, back, animate)
        setAnimationControlType: (state, action) => {
            state.animationControlType = action.payload
        },

        //! bu canlı konumda sokak görünümnü kontrol ediyor
        setLiveStreetView: (state,action) => {
            state.liveStreetView = action.payload
        },

        //! trafik durumunu tutan
        setIsTrafficLayer: (state, action) => {
            state.isTrafficLayer = action.payload
        },

        //! bu animasyon kımında hangi marker ın gösterileceiğinin order ı
        setActiveLocationOrderForAnimation: (state, action) => {
            state.activeLocationOrderForAnimation = action.payload
        },


        //! bu animasyon tabında animasyon un hızını gösteren
        setAnimationControlSpeed: (state, action) => {
            state.animationControlSpeed = action.payload
        },


        //! bu animasyon tabının çizgi mi yoksa icon mu olacağını ayarlayan
        setAnimationViewType: (state,action) => {
            state.animationViewType = action.payload
        },

        //! bu animasyon kısmında location pointlerden siyah olanları filtrelemek için
        setLocationPointPauseFilter:(state, action) => {
            state.locationPointPauseFilter = action.payload
            state.maxSpeedFilter = action.payload && false
        },

        //! bu başlangıç tarihini filtreleyen
        setMarkerFilterStartDate: (state, action) => {
            state.filterStartDate = action.payload
        },

        //! bu bitiş tarihini filtreleyen
        setMarkerFilterEndDate: (state, action) => {
            state.filterEndDate = action.payload
        },

        //! max speed e göre filtreleme yapılıp yapılmayacağını gösterir
        setMaxSpeedFilter:(state,action) => {
            state.maxSpeedFilter = action.payload
            state.locationPointPauseFilter = action.payload && false
        },

        //! max speed e göre filtreleme yapılacak değeri gösterir
        setMaxSpeedValue:(state,action) => {
            state.maxSpeedValue = action.payload
        },

        //! bu animasyon ile takip ederken haritaya focuslanıp focuslanmayacağını kontrol ediyor.
        setAnimationFocusType: (state, action) => {
            state.animationFocusType = action.payload
        },

        //! bu haritanın görünür alanındaki marker listesini güncelleyen (optimizasyon için)
        setDetailsVisibleMarkers: (state, action) => {
            state.detailsVisibleMarkers = action.payload
        },

        //! bu haritanın sağ üst köşesindeki location detaylarını tutan (marker a tıklama yada animasyon sırasında değişiyor) 
        setDetailsMarkerItem: (state, action) => {
            state.detailsMarkerItem = action.payload
        },

        //! bu detay haritasında hangi tab ın açık olacağını ayarlıyor
        setActiveTabId: (state, action) => {
            state.activeTabId = action.payload
        },

        //! bunu animasyon tabında rotanın başı ve sonu arsındaki ilgili marker a(konum a) gitmek için ( slider üzerinde)
        setAnimationControlRoute: (state, action) => {
            state.animationControlRoute = action.payload
        },

        //! bu listelerde haritanın sağında veri kısmının gösterilmesini setleyen
        setIsActiveSide: (state, action) => {
            state.isActiveSide = action.payload
        },

        
        addLiveLocationDataToShipmentItemLocationList: (state, action) => {

            const {lastLiveLocationData} = action.payload
            
            //! topPagesMapSingleShipmentItemLocationList (burası güncellenecek)

            if(lastLiveLocationData?.shipmentId === state.topPagesMapShipmentItemCurrentLocationData?.shipmentId){
                state.topPagesMapShipmentItemCurrentLocationData = {...state?.topPagesMapShipmentItemCurrentLocationData, currentDriverLocation:lastLiveLocationData }
                state.topPagesMapSingleShipmentItemLocationList = [...state?.topPagesMapSingleShipmentItemLocationList, lastLiveLocationData ]
            }

            state.topPagesMapAllShipmentCurrentLocationList = state.topPagesMapAllShipmentCurrentLocationList?.map((item) => {
                if(item?.shipmentId === lastLiveLocationData?.shipmentId){
                    return {
                        ...item,
                        currentDriverLocation:lastLiveLocationData
                    }
                }
                else{
                    return item
                }
            })
        },


        //! **********************************************************************************************************************************************************************************************


        setShareLinkShipmentId:(state, action) => {
            state.shareLinkShipmentId = action.payload
        },


        addLiveLocationDataToTrackingShipmentItemLocationList: (state,action) => {
            state.trackingDatalocationList = [...state.trackingDatalocationList, action.payload]
            state.trackingDataCurrentDriverLocation = action.payload
        },

        //! **********************************************************************************************************************************************************************************************

        setRemainingDistance:(state, action) => {
            state.remainingDistance = action.payload
        },


        setTekSuruculuTahminiVaris: (state, action) => {
            state.tekSuruculuTahminiVaris = action.payload
        },

        setCiftSuruculuTahminiVaris: (state, action) => {
            state.ciftSuruculuTahminiVaris = action.payload
        },
        
        //! slice ı resetleyen
        resetAllState: () => initialState

    },
    extraReducers:(builder)=> {
        builder

        //! getHomePageMapShipmentData
        .addCase(getHomePageMapShipmentData.pending, (state)=> {
        })

        .addCase(getHomePageMapShipmentData.fulfilled, (state, action)=> {
            state.homePageLocationData = {...state.homePageLocationData, ...action.payload}
        })

        .addCase(getHomePageMapShipmentData.rejected, (state, action)=> {
        })

        //! getHomePageMapLoadData
        .addCase(getHomePageMapLoadData.pending, (state)=> {
        })

        .addCase(getHomePageMapLoadData.fulfilled, (state, action)=> {
            state.homePageLocationData = {...state.homePageLocationData, ...action.payload}
        })

        .addCase(getHomePageMapLoadData.rejected, (state, action)=> {
        })

        //! getShipmentDriverLocationsById
        .addCase(getShipmentDriverLocationsById.pending, (state)=> {
            state.isLoadingGetShipmentDriverLocationsById = true
        })

        .addCase(getShipmentDriverLocationsById.fulfilled, (state, action)=> {
            state.isLoadingGetShipmentDriverLocationsById = false

            const {data, fromWhere} = action.payload
            
            if(fromWhere === "tamamlanan"){
                state.topPagesMapSingleTamamlananShipmentItemLocationList = data
            }
            else{
                state.topPagesMapSingleShipmentItemLocationList = data
            }
        })

        .addCase(getShipmentDriverLocationsById.rejected, (state, action)=> {
            state.isLoadingGetShipmentDriverLocationsById = false
        })

        //! getLocationTrackingShareLink
        .addCase(getLocationTrackingShareLink.pending, (state)=> {
            state.isLoadingGetLocationTrackingShareLink = true
        })

        .addCase(getLocationTrackingShareLink.fulfilled, (state, action)=> {
            state.isLoadingGetLocationTrackingShareLink = false
            state.locationTrackingShareLink = action.payload.data.locationShareLinkId
        })

        .addCase(getLocationTrackingShareLink.rejected, (state, action)=> {
            state.isLoadingGetLocationTrackingShareLink = false
        })

        //! getLocationTrackingData
        .addCase(getLocationTrackingData.pending, (state)=> {
            state.isLoadingGetLocationTrackingData = true
        })

        .addCase(getLocationTrackingData.fulfilled, (state, action)=> {
            state.isLoadingGetLocationTrackingData = false
            const {
                currentDriverLocation,
                driverInfo,
                locations,
                loadRoutePoints
            } = action.payload
            
            state.trackingDatalocationList = locations
            state.trackingDataDriverInfo = driverInfo
            state.trackingDataCurrentDriverLocation = {...currentDriverLocation, createdDate: addThreeHoursToISO(currentDriverLocation.createdDate)} 
            state.trackingDataLoadRoutePoints = loadRoutePoints

        })

        .addCase(getLocationTrackingData.rejected, (state, action)=> {
            state.isLoadingGetLocationTrackingData = false
        })
        
        //! sendShipmenLiveLocationShareLinkWithMail
        .addCase(sendShipmenLiveLocationShareLinkWithMail.pending, (state)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithMail = true
        })

        .addCase(sendShipmenLiveLocationShareLinkWithMail.fulfilled, (state, action)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithMail = false

        })

        .addCase(sendShipmenLiveLocationShareLinkWithMail.rejected, (state, action)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithMail = false
        })

        //! sendShipmenLiveLocationShareLinkWithSms
        .addCase(sendShipmenLiveLocationShareLinkWithSms.pending, (state)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithSms = true
        })

        .addCase(sendShipmenLiveLocationShareLinkWithSms.fulfilled, (state, action)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithSms = false

        })

        .addCase(sendShipmenLiveLocationShareLinkWithSms.rejected, (state, action)=> {
            state.isLoadingSendShipmenLiveLocationShareLinkWithSms = false
        })



        

        

    }
})


export const {

    setTopPagesMapAllShipmentCurrentLocationList,

    setTopPagesMapShipmentItemCurrentLocationData,

    setTopPagesMapAllTamamlananShipmentCurrentLocationList,

    setTopPagesMapTamamlananShipmentItemCurrentLocationData,

    setAnimationControlType,

    setLiveStreetView,

    setIsTrafficLayer,

    setActiveLocationOrderForAnimation,

    setAnimationControlSpeed,

    setAnimationViewType,

    setLocationPointPauseFilter,

    setMarkerFilterStartDate,

    setMarkerFilterEndDate,

    setMaxSpeedFilter,

    setMaxSpeedValue,

    setAnimationFocusType,

    setDetailsVisibleMarkers,

    setDetailsMarkerItem,

    setActiveTabId,

    setAnimationControlRoute,

    setIsActiveSide,

    addLiveLocationDataToShipmentItemLocationList,

    setShareLinkShipmentId,

    //!
    addLiveLocationDataToTrackingShipmentItemLocationList,

    //!
    setTekSuruculuTahminiVaris,

    //!
    setCiftSuruculuTahminiVaris,


    //!
    setRemainingDistance,



    resetAllState
} = topPagesMapSlice.actions
export default topPagesMapSlice.reducer